import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';

import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import InputBase from '@material-ui/core/InputBase';
import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3)
    }
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)'
    }
  }
}))(InputBase);

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1)
  }
}));

export default function CustomizedSelects({ option, onUserInput, isSelected }) {
  const classes = useStyles();
  let initialValue;
  let gramCollector;
  let meterCollector;
  let yearCollector;
  switch (option[0].label) {
    case 'Meter':
      meterCollector = true;
      initialValue = '100';
      break;
    case 'Kilogram':
      gramCollector = true;
      initialValue = '1';
      break;
    default:
      yearCollector = true;
      initialValue = 'Years';
      break;
  }
  const [age, setAge] = React.useState('');
  const [ageType, setAgeType] = React.useState(initialValue);
  // const isSelectedClass = isSelected ? 'boot-strap__button--selected' : '';
  const [displayForm, setDisplayForm] = React.useState('block');
  const handleChangeAge = (event) => {
    console.log('ageType ', ageType);
    let theAgeInput = event.target.value;
    if (ageType == 'Years') {
      console.log(theAgeInput);
      console.log(theAgeInput >= 120);
      if (theAgeInput >= 120) {
        theAgeInput = 120;
      }
      if (theAgeInput < 0) {
        theAgeInput = 0;
      }
    }
    setAge(theAgeInput);
  };
  const handleChangeAgeType = (event) => {
    setAgeType(event.target.value);
  };

  const handleSubmit = () => {
    setDisplayForm('none');
    if (meterCollector || gramCollector) {
      console.log('String contains number');
      const finalResult = parseFloat(age) * parseFloat(ageType);
      onUserInput('user submit', finalResult.toString());
    } else {
      onUserInput('user submit', `${age} ${ageType}`);
    }
  };
  option.forEach((element) =>
    console.log('Element in TypeinCollection: ', element.label)
  );

  return (
    <div style={{ display: displayForm }}>
      <FormControl className={classes.margin}>
        <BootstrapInput
          id="demo-customized-textbox"
          onChange={handleChangeAge}
          value={age}
          type="number"
        />
      </FormControl>
      <FormControl className={classes.margin}>
        <Select
          labelId="demo-customized-select-label"
          id="demo-customized-select"
          onChange={handleChangeAgeType}
          defaultValue={ageType}
          input={<BootstrapInput />}
        >
          <MenuItem>Choose a unit</MenuItem>

          {option.map((item) => (
            <MenuItem value={item.value}>{item.label}</MenuItem>
          ))}
          {/* '<MenuItem value="Years">Years</MenuItem>' */}
          {/* '<MenuItem value="Months">Months</MenuItem>' */}
          {/* '<MenuItem value="Days">Days</MenuItem>' */}
        </Select>
      </FormControl>
      <FormControl className={classes.margin}>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={isSelected}
        >
          Submit
        </Button>
      </FormControl>
    </div>
  );
}

CustomizedSelects.propTypes = {
  option: PropTypes.object.isRequired,
  onUserInput: PropTypes.func.isRequired,
  isSelected: PropTypes.bool
};

CustomizedSelects.defaultProps = {
  isSelected: false
};



// WEBPACK FOOTER //
// ./src/components/TypeInCollection/TypeInCollection.js